import { TabList as ChakraTabList, type TabListProps } from "@chakra-ui/react"

import { scrollFadeMask, useScrollEdges } from "@/hooks/useScrollEdges"

// Chakra's TabList, scrolling sideways on a narrow screen (theme): the edges hiding tabs fade out
// and the selected tab is brought into view.
export const TabList: React.FC<TabListProps> = ({ sx, ...props }) => {
  const { ref, start, end } = useScrollEdges<HTMLDivElement>('[aria-selected="true"]')

  return (
    <ChakraTabList
      ref={ref}
      sx={{ ...scrollFadeMask({ start, end }), ...sx }}
      data-overflow-start={start || undefined}
      data-overflow-end={end || undefined}
      {...props}
    />
  )
}
